export default "__VITE_ASSET__B3o1l4iu__"